import styled from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import { WhiteBlock } from 'components/Layout'
import { Mark } from 'components/Mark'
import { BodyPrimary, Font14 } from 'components/Typography'
import { StyledIcon, Title } from 'features/home/components/HomeStatus/styles'

export const StyledMainInfoContainer = styled(WhiteBlock)`
  width: 100%;
  margin-bottom: ${theme.spacing.s};
  padding: 24px;

  @media ${theme.devices.tablet} {
    margin-bottom: ${theme.spacing.base};
  }
`

export const StyledLabel = styled(BodyPrimary)`
  margin-bottom: 8px;
`

export const StyledTitle = styled(Title)``

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  @media ${theme.devices.tablet} {
    margin-bottom: 28px;
  }
`

export const DesktopHeaderTitle = styled(Title)`
  display: none;
  font-size: 32px;
  line-height: 32px;
  margin-left: 24px;
  @media ${theme.devices.tablet} {
    display: block;
    word-break: break-word;
  }
`

export const MobileHeaderTitle = styled(Title)`
  width: 100%;
  display: block;
  font-size: 32px;
  line-height: 32px;
  margin-bottom: 24px;
  word-break: break-word;

  @media ${theme.devices.tablet} {
    display: none;
  }
`

export const HeaderIcon = styled(StyledIcon)`
  margin-left: 16px;
  @media ${theme.devices.tablet} {
    margin-left: 24px;
  }
`

export const LeftBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const RightBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const MobileMark = styled(Mark)`
  margin-right: 20px;
  @media ${theme.devices.tablet} {
    display: none;
  }
`

export const MarginMark = styled(Mark)`
  margin-right: 20px;
`

export const StatusWrapper = styled.div<{ status: boolean }>`
  display: none;
  height: 40px;
  padding: 13px 16px;
  align-items: center;
  color: ${theme.colors.otterWarmBlack};
  border-radius: 8px;
  background: ${({ status }) =>
    status ? theme.colors.successBack : theme.colors.unsuccessBack};
  ${Font14};
  @media ${theme.devices.tablet} {
    display: flex;
  }
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px 0;
  @media ${theme.devices.tablet} {
    gap: 32px 0;
    flex-direction: row;
  }
`

export const baseBlockStyles = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 44px;
  flex-basis: 100%;

  @media ${theme.devices.tablet} {
    flex-basis: 50%;
  }

  @media ${theme.devices.desktop} {
    flex-basis: 33.33%;
    min-height: 64px;
  }
`

export const HomeStatusSystemAccess = styled(baseBlockStyles)``

export const HomeStatusMonitoringAccess = styled(baseBlockStyles)``

export const HomeStatusSuccessBox = styled.div`
  align-items: center;
  display: flex;
  background-color: ${theme.colors.successBack};
  border-radius: 8px;
  ${Font14};
  padding: 11px 23px;
  width: max-content;
`

export const HomeStatusSuccessBoxIcon = styled(Icon)`
  margin-right: 12px;
`

export const ConfigurableCard = styled.div<{
  color: string
  width?: string
  isLoading?: boolean
}>`
  background-color: ${({ color }) => color};
  padding: 24px;
  min-height: 112px;
  border-radius: 8px;
  display: flex;
  justify-content: ${({ isLoading }) =>
    isLoading ? 'center' : 'space-between'};
  align-items: center;
  flex-basis: ${({ width }) => width || '50%'};
  @media ${theme.devices.tablet} {
    flex-basis: ${({ width }) => width};
    min-height: 96px;
    padding: 16px;
  }
  @media ${theme.devices.desktop} {
    flex-basis: 19%;
  }
`

export const ConfigurableLabelSymbol = styled.span`
  font-size: 16px;
`

export const ConfigurableCardLabel = styled.div<{ color?: string }>`
  font-size: 32px;
  min-height: 42px;
  display: flex;
  align-items: flex-end;
  line-height: 0.7;
  color: ${(p) => p.color || theme.colors.duneWarmGrey};
  font-weight: 600;
`

export const HomeStatusStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const ConfigurableCardTitile = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${theme.colors.duneWarmGrey};
  white-space: nowrap;
`

export const StatusIconContainer = styled.div``

export const StyledQuestionIcon = styled(Icon)`
  margin-left: 10px;
  display: flex;
  color: ${theme.colors.duneWarmGrey};
  cursor: pointer;
`

export const LightStatuses = styled.div`
  gap: ${theme.spacing.xs};
  display: flex;
  flex-direction: column;
  font-size: 12px;
  @media ${theme.devices.tablet} {
    display: flex;
    flex-basis: 50%;
    justify-content: center;
    align-items: flex-start;
  }
  @media ${theme.devices.desktop} {
    flex-basis: unset;
    min-width: 170px;
  }
`

export const LightStatusContainer = styled.div`
  display: flex;
  min-height: 16.8px;
`

export const IndicatorsContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 16px;
`

export const HomeStatusLabelsContainer = styled.div`
  display: flex;
  align-items: center;
`

export const HomeStatusCircle = styled.div<{
  status?: boolean | string
  hideOnTabletAndUp?: boolean
}>`
  background: ${({ color }) => color};
  flex: none;
  border-radius: 50%;
  margin-right: 16px;
  height: ${theme.spacing.s};
  width: ${theme.spacing.s};
  ${({ status }) =>
    status
      ? `background: ${theme.colors.successGreen};`
      : `background: ${theme.colors.error};`}
  @media ${theme.devices.tablet} {
    ${({ hideOnTabletAndUp }) => hideOnTabletAndUp && 'display: none;'}
  }
`

export const HomeStatusKebabContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const HomeStatusKebabItem = styled.div<{ disabled?: boolean }>`
  &:hover {
    color: ${theme.colors.horizonOrange};
  }
  cursor: pointer;
  padding-right: 61px;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : '')};
  color: ${({ disabled }) => (disabled ? theme.colors.darkeyGrey : '')};
`

export const HomeKebabModalContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const KebabModalTitle = styled.div`
  margin-top: 16px;
  font-size: 20px;
  font-weight: 600;
`

export const KebabModalLabel = styled.div`
  margin-top: 48px;
  text-align: center;
  white-space: pre-line;
  line-height: 1.8;
`

export const HomeKebabButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 48px;
`
